import { motion } from 'motion/react';

function FoundationLoader() {
  return (
    <div
      aria-live="polite"
      role="status"
      style={{
        width: '100%',
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <motion.svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        animate={{ scale: [1, 1.5, 1] }}
        transition={{ duration: 1, ease: 'easeInOut', repeat: Number.POSITIVE_INFINITY }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.3741 11.9426C29.7593 13.685 30 15.2317 30 16.687C30 19.4931 29.0913 21.8686 26.6359 24.4137C24.5055 26.6587 21.9178 28.3359 19.1374 29.4649C18.2287 29.8368 17.3079 30 16.3992 30C13.4804 30 10.6219 28.3359 8.22668 26.5151C7.17352 25.6928 6.02407 24.9946 5.001 24.1266C3.47843 22.8671 2.70812 20.8832 2.14243 18.945C1.35406 16.1714 0.234704 13.5741 0.0300903 10.6047C0 10.3437 0 10.0827 0 9.82815C0 7.92256 0.818455 6.29106 2.15446 4.88797C3.14142 3.84381 4.34504 2.85839 5.59679 2.17968C7.02307 1.40309 8.38916 0.841853 9.95386 0.417664C11.1274 0.0783119 12.2467 0 13.318 0C17.0853 0 20.3892 2.08179 23.4343 4.90755C23.8556 5.27953 24.3129 5.63193 24.7884 5.93866C25.655 6.5521 26.666 6.85882 27.4965 7.50489L27.5266 7.53752C28.7783 8.536 29.001 10.409 29.3741 11.9426ZM28.6158 17.3461C28.6158 16.5564 28.4233 15.7994 27.9478 15.2186C27.2437 14.442 26.01 14.2789 25.0712 13.6981C23.8556 13.0389 23.007 11.8577 22.333 10.5721C21.2317 8.45769 19.8656 6.48684 18.1866 4.90755C17.0371 3.86991 15.653 3.21079 14.2267 2.70829C13.1856 2.32325 12.0843 2.14705 10.995 2.14705C7.97392 2.14705 4.91073 3.56319 2.85858 6.00392C1.94985 7.06765 1.19157 8.43811 1.19157 9.9913C1.19157 11.6815 2.1003 13.1499 3.27382 14.1353C4.40521 15.0424 5.81946 15.6559 6.86058 16.8175C7.52859 17.5549 8.09428 18.4425 8.65998 19.3169C9.94182 21.2878 11.2778 23.2521 13.1073 24.5769C14.8345 25.8364 16.8746 26.4499 18.8967 26.4499C22.5617 26.4499 26.7563 24.1266 28.1825 19.7216L28.2006 19.6889C28.4233 18.9776 28.6158 18.1357 28.6158 17.3461Z"
          fill="#393AFB"
        />
      </motion.svg>
    </div>
  );
}

export { FoundationLoader };
